import { render } from "./TagItem.vue?vue&type=template&id=762c0f13"
import script from "./TagItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TagItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paragraphs/TagItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "762c0f13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('762c0f13', __exports__)) {
    api.reload('762c0f13', __exports__)
  }
  
  module.hot.accept("./TagItem.vue?vue&type=template&id=762c0f13", () => {
    api.rerender('762c0f13', render)
  })

}


export default __exports__